import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_nrc47wnxxn: FaireBrandEntity = {
  token: "b_nrc47wnxxn",
  type: "brand",
  name: "Puzzle Weekend",
  avatarUrl:
    "https://cdn.faire.com/fastly/97f274842020457df57a09a28f3be5865441698232751feb7c83a0f2e51ee5a2.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/60e3015eaeaa12f21634f7f2b76a17247ac679ddbb6beadbc4b3e1ed44335af7.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/97f274842020457df57a09a28f3be5865441698232751feb7c83a0f2e51ee5a2.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/60e3015eaeaa12f21634f7f2b76a17247ac679ddbb6beadbc4b3e1ed44335af7.jpeg",
  location: "Vancouver, WA, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 9,
  isTopShop: true,
  isInsider: true,
  description:
    "Puzzle Weekend was born from the desire to do less, together. We work with talented artists to create beautiful, intricate puzzles that can be enjoyed solo, or even better, with loved ones. We’re Jenn and Kelly, sisters-in-law and co-owners of Puzzle Weekend. Before we went into business together, we spent as much of our free time as possible working on puzzles together. This meant bringing puzzles on family vacations, carving out free evenings after work, or even booking long weekends at the coast with the sole purpose of completing as many puzzles as possible! It only made sense that we launch a puzzle business together.\n\nWhat began as a shared hobby soon grew into something more: a chance to design puzzles we wished existed. We started licensing artwork from female artists we admire, building a collection that celebrates creativity, connection, and beauty. Each puzzle is not only a labor of love, but also a collaboration pairing thoughtful design with illustrations that inspire joy, wonder, and togetherness.",
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:55:11.213Z",
    importedBy: "entity-db-cli",
  },
};
